import { CellProps } from "react-table";
import TextCell from "src/components/tables/cells/TextCell";
import { getGenderLabel } from "src/helpers/helpers";
import ActionsCell from "./ActionsCell";
import { ClientType } from "./client-types";

const useClientTableColumns = ({
  onDelete,
}: {
  onDelete: (id: number) => void;
}) => {
  return [
    {
      Header: "Name",
      accessor: "name",
      className: "min-w-[180px]",
      Cell: TextCell,
    },
    {
      Header: "Phone",
      accessor: "phone",
      className: "min-w-[150px]",
      Cell: TextCell,
    },
    {
      Header: "Email",
      accessor: "email",
      className: "min-w-[150px]",
      Cell: TextCell,
    },
    {
      Header: "Address",
      accessor: "address",
      className: "min-w-[150px]",
      Cell: TextCell,
    },
    //Will be the part of Phase 2
    // {
    //   Header: "Wallet",
    //   accessor: "wallet",
    //   className: "min-w-[150px]",
    //   Cell: ({ value, row }: CellProps<ClientType>) => {
    //     return <TextCell value={value ?? 0} />;
    //   },
    // },
    {
      Header: "Date Of Birth",
      accessor: "dob",
      className: "min-w-[150px]",
      Cell: TextCell,
    },
    {
      Header: "Gender",
      accessor: "gender",
      className: "min-w-[150px]",
      Cell: ({ value, row }: CellProps<ClientType>) => {
        return <TextCell value={getGenderLabel(value) as string} />;
      },
    },
    {
      Header: "Actions",
      accessor: "id",
      className: "min-w-[200px]",
      Cell: ({ value }: CellProps<ClientType>) => (
        <ActionsCell value={value} onDelete={() => onDelete(value)} />
      ),
    },
  ];
};

export default useClientTableColumns;
